import "./style.css";

const Footer = () => {
  return (
    <footer id="footer">
      <a
        href="https://www.instagram.com/sr44.exe/"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-instagram"></i>
      </a>
      <a
        href="https://twitter.com/Shubham_Sr44"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-twitter"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/shubham-raut-8b185a1a6/"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-linkedin"></i>
      </a>
      <a
        href="https://github.com/shubham44-code"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fab fa-github"></i>
      </a>
    </footer>
  );
};

export default Footer;
